import { verifyOtpStart, verifyOtpSuccess, verifyOtpError } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import { verifyOTP as verifyOTPApi } from "helpers/backend_helper";
import { toast } from "react-toastify";

interface VerifyOtpPayload {
    email: string;
    otp: string;
}

export const verifyOTP =
    (
        payload: VerifyOtpPayload,
        navigate: any
    ): ThunkAction<void, RootState, unknown, Action<string>> =>
        async (dispatch: Dispatch) => {
            dispatch(verifyOtpStart(payload.otp));
            try {
                const response: any = await verifyOTPApi(payload);
                if (response && response.data && response.data.success) {
                    dispatch(verifyOtpSuccess());
                    toast.success("OTP verification successful!");
                    
                    // Redirect to the confirm password page or any other page
                    navigate("/confirm-password");
                } else {
                    throw new Error(response.data.message);
                }
            } catch (error: any) {
                dispatch(verifyOtpError(error));
                toast.error("Failed to verify OTP");
            }
        };
